module.exports = __webpack_public_path__ + "img/business_3.cceeacaf.jpg";